type CompanionTipScrollMetrics = {
	scrollTop: number;
	clientHeight: number;
	scrollHeight: number;
};

const EMPTY_COMPANION_TIP_SCROLL_METRICS = {
	scrollTop: 0,
	clientHeight: 0,
	scrollHeight: 0,
};

export const getCompanionTipScrollMetrics = ({
	scrollTarget,
	fallbackScrollContainer,
	fallbackScrollTop,
	fallbackClientHeight,
	fallbackScrollHeight,
}: {
	scrollTarget: EventTarget | null;
	fallbackScrollContainer: HTMLElement | null;
	fallbackScrollTop: number;
	fallbackClientHeight: number;
	fallbackScrollHeight: number;
}): CompanionTipScrollMetrics => {
	const isElementScrollTarget = scrollTarget instanceof HTMLElement;
	if (isElementScrollTarget && !fallbackScrollContainer) {
		return EMPTY_COMPANION_TIP_SCROLL_METRICS;
	}

	const hasMainContentContainer = fallbackScrollContainer instanceof HTMLElement;
	const isElementScrollTargetInsideMainContent =
		isElementScrollTarget &&
		hasMainContentContainer &&
		fallbackScrollContainer.contains(scrollTarget);

	if (isElementScrollTarget && hasMainContentContainer && !isElementScrollTargetInsideMainContent) {
		return EMPTY_COMPANION_TIP_SCROLL_METRICS;
	}

	if (
		isElementScrollTargetInsideMainContent &&
		scrollTarget.scrollHeight > scrollTarget.clientHeight
	) {
		return {
			scrollTop: scrollTarget.scrollTop,
			clientHeight: scrollTarget.clientHeight,
			scrollHeight: scrollTarget.scrollHeight,
		};
	}

	if (
		fallbackScrollContainer instanceof HTMLElement &&
		fallbackScrollContainer.scrollHeight > fallbackScrollContainer.clientHeight
	) {
		return {
			scrollTop: fallbackScrollContainer.scrollTop,
			clientHeight: fallbackScrollContainer.clientHeight,
			scrollHeight: fallbackScrollContainer.scrollHeight,
		};
	}

	return {
		scrollTop: fallbackScrollTop,
		clientHeight: fallbackClientHeight,
		scrollHeight: fallbackScrollHeight,
	};
};

export const getCompanionTipScrollDepthY = ({
	scrollTop,
	clientHeight,
	scrollHeight,
}: CompanionTipScrollMetrics): number => {
	if (scrollHeight <= 0) {
		return 0;
	}

	return Math.trunc(((scrollTop + clientHeight) / scrollHeight) * 100) / 100;
};
